export const ServiceProviderSymbol = Symbol('ServiceProvider')
export const ServiceProviderAdapterSymbol = Symbol('ServiceProviderAdapter')
export const SignalsPageServiceProviderSymbol = Symbol('SignalsPageServiceProvider')
export const SignalsServiceProviderSymbol = Symbol('SignalsServiceProvider')
export const SiteServicesManagerSymbol = Symbol('SiteServicesManager')
export const PageServicesManagerSymbol = Symbol('PageServicesManager')
export const SiteServicesProviderSymbol = Symbol('SiteServicesProvider')
export const SiteServicesManagerAdapterSymbol = Symbol('SiteServicesManagerAdapter')
